(function () {
    "use strict";

    angular.module("app").component("cisInfoView", {
        templateUrl: "@/cis/cis-info-view.template.html",
        bindings: {
            request: "<",
            allowedLevels: "<",
        },
        controller: ViewController
    });

    ViewController.$inject = ["$rootScope"];
    function ViewController($rootScope) {
        const vm = this;

        vm.VMTypes = $rootScope.codeVMTypes;
        vm.VMLevels = $rootScope.codeIVMLevels;
    }
})();